import { Loader2 } from "lucide-react";

export function FullScreenLoader({ label = "Loading…" }: { label?: string }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="glass rounded-3xl px-6 py-5 flex items-center gap-3 animate-fade-in">
        <Loader2 className="w-5 h-5 animate-spin text-brand-200" />
        <span className="text-sm text-slate-200">{label}</span>
      </div>
    </div>
  );
}

export function Spinner({
  size = 16,
  className = "",
}: {
  size?: number;
  className?: string;
}) {
  return (
    <Loader2 width={size} height={size} className={`animate-spin ${className}`} />
  );
}
